export const PAYMENT_TYPE_JOB = "job";
export const PAYMENT_TYPE_UPSELL = "upsell";
export const PAYMENT_TYPE_ALL_ACCESS = "all_access";
